import React from 'react';
import Combobox from './primitives/Combobox';
import Accounts from '../../../views/Accounts';
import { t } from '../l10n/l10n';
import { useAccounts } from '../../hooks/masterdata/useAccounts';

interface Props {
    isBlockedForDirectEntries?: boolean;
    onCreated?: Function;
    hideSummary?: boolean;
    [x: string]: any;
    modalDraggable?: boolean;
    onAccountSelected?: (account: number) => void;
    showAllAccounts?: boolean;
    showAllAccountTypes?: boolean;
    allowHeadingClick?: boolean;
    width?: string;
}

export default function AccountCombobox({
    isBlockedForDirectEntries,
    onCreated,
    hideSummary = false,
    onAccountSelected,
    showAllAccountTypes = false,
    allowHeadingClick = false,
    width,
    showAllAccounts = false,
    ...props
}: Props) {
    const { data: accounts } = useAccounts({
        showAllAccounts,
        showAllAccountTypes,
        // If heading accounts are not clickable in the Accounts modal,
        // they should also not be shown in the combobox dropdown options
        showHeadingAccounts: allowHeadingClick,
        isBlockedForDirectEntries,
    });

    return (
        <Combobox
            {...props}
            aria-label={t`MODAL_CHART_OF_ACCOUNTS_TITLE`}
            data={accounts.map(account => ({
                data: account,
                text: `${account.number} - ${account.name}`,
                summary: hideSummary ? undefined : account.name,
                value: account.number,
            }))}
            onChange={account => {
                props.onChange?.(account); // invoke form system onChange handler
                onAccountSelected?.(account);
            }}
            modal={({ hide, onChange }) => (
                <Accounts
                    modalDraggable={props.modalDraggable}
                    onCreated={account => {
                        onCreated?.();
                        onChange(account.number, account, true);
                        onAccountSelected?.(account.number);
                        hide();
                    }}
                    onSelected={account => {
                        onChange(account.number, account);
                        onAccountSelected?.(account.number);
                        hide();
                    }}
                    selectedAccountNumber={props.value}
                    showAllAccounts={showAllAccounts}
                    showAllAccountTypes={showAllAccountTypes}
                    allowHeadingClick={allowHeadingClick}
                />
            )}
            modalSize="sm"
            className={width || 'w-36'}
        />
    );
}
